import { USER } from '../constant/actionTypes';

const getUserData = (state, action) => {
  switch (action.type) {
    case USER.DATA.INITIATE:
      return { isFetching: false };
    case USER.DATA.SUCCESS:
      return { isFetching: true, data: action.payload };
    case USER.DATA.ERROR:
      return { isFetching: true, data: action.payload };
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getUserData;
